/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ winsPerDay: NonNullable<unknown>, days: NonNullable<unknown> }} Dropdailysummary2Inputs */

const en_dropdailysummary2 = /** @type {(inputs: Dropdailysummary2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.winsPerDay} wins per day · voucher valid ${i?.days} days`)
};

const de_dropdailysummary2 = /** @type {(inputs: Dropdailysummary2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.winsPerDay} Gewinne pro Tag · Gutschein ${i?.days} Tage gültig`)
};

/**
* | output |
* | --- |
* | "{winsPerDay} wins per day · voucher valid {days} days" |
*
* @param {Dropdailysummary2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailysummary2 = /** @type {((inputs: Dropdailysummary2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailysummary2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailysummary2(inputs)
	return de_dropdailysummary2(inputs)
});
export { dropdailysummary2 as "dropDailySummary" }